import PitchCall from "../../enums/PitchCall.js";

// pitches at which batter swings and hits the ball
// @see https://www.bleachernation.com/cubs/2015/03/10/swing-rates-contact-rates-and-you-part-one/
// @see https://library.fangraphs.com/offense/plate-discipline/
// @see https://www.fantraxhq.com/sabermetric-series-part-3-plate-discipline/

const classifiesAsContact = function(pitchCall) {
    switch (pitchCall) {
        case PitchCall.BallInPlay.key:
        case PitchCall.FoulBall.key:
        case PitchCall.FoulBunt.key:
        case PitchCall.FoulTip.key: // todo, not sure ? A foul tip is considered equivalent to a ball in which the batter swings and misses see https://www.mlb.com/glossary/rules/foul-tip https://www.pitcherlist.com/csw-rate-an-intro-to-an-important-new-metric/
        //case PitchCall.Unidentified.key: // TODO - not sure about this one ?
            return true;

        default:
            return false;
    }
};

export default classifiesAsContact;